export default {"src":"/_next/static/media/reports.c64d9196.svg","height":51,"width":50};